import HappyChildren from "assets/images/jpgs/HappyChildren.jpg";
import { HOWDONATIONWORKSDATA } from "utilities/data";
import AboutUsInfo from "./components/AboutUsInfo";
import DonateCard from "./components/DonateCard";
import Button from "shared/Button";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import EmptyProjects from "shared/EmptyProjects";

const HowDonationWorks = () => {
  const { projects } = useSelector((state) => state.project);
  const slicedDonateArr = projects?.slice(0, 3);

  const theme = ["bg-[#FF8F41]", "bg-[#61CE70]", "bg-[#0693E3]"];

  return (
    <div className="px-16 max-[450px]:px-8 py-12 gap-4">
      <div className="flex max-md:flex-wrap gap-12 justify-center items-center">
        <div className="md:w-2/5">
          <img
            className="w-full h-full"
            src={HappyChildren}
            alt="HappyChildrenImg"
          />
        </div>
        <div className="md:w-3/5">
          <AboutUsInfo
            header={HOWDONATIONWORKSDATA.header}
            list={HOWDONATIONWORKSDATA.list}
          />
          <Link to="/donate-money">
            <Button className="bg-[#FFFFFF]">DONATE NOW</Button>
          </Link>
        </div>
      </div>
      {projects?.length < 1 ? (
        <div className="border-y my-8">
          <EmptyProjects />
        </div>
      ) : (
        <div className="mt-10 flex gap-6 justify-center max-md:flex-wrap">
          {slicedDonateArr?.map((donateCard, idx) => (
            <div className="w-[300px]" key={donateCard._id}>
              <DonateCard
                id={donateCard._id}
                cardImage={donateCard.project_picture}
                title={donateCard.name}
                body={donateCard.summary}
                amountRaised={donateCard.amountDonated}
                targetAmount={donateCard.fundraising_goal}
                bgColor={theme[idx % 3]}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default HowDonationWorks;
